import { render } from "./InsurancePage.vue?vue&type=template&id=15b12ab6"
import script from "./InsurancePage.vue?vue&type=script&lang=js"
export * from "./InsurancePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__